export class DeploymentNavStorage {
    // Use a global key for date
    saveDate(date: Date): void {
        localStorage.setItem(`deployment_nav_global_date`, date.toISOString());
    }

    loadDate(): Date | null {
        const stored = localStorage.getItem(`deployment_nav_global_date`);
        return stored ? new Date(stored) : null;
    }

    clear(): void {
        localStorage.removeItem(`deployment_nav_global_date`);
    }
}
